var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { noPadding: "", title: "Monthly RISS Report", icon: "poll" },
      }),
      _vm._v(" "),
      _vm.globalIsLoading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          attrs: {
            type: "info",
            value:
              !_vm.globalIsLoading && _vm.reportVisibilityOption.length == 0,
          },
        },
        [
          _vm._v(
            "\n    There are no report types activated for this tenant.\n    Please contact the system administrator to activate reports.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.selectedReport === null && !_vm.globalIsLoading
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.reportTypeIsVisible(_vm.reportObjects.riss.configKey)
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", md12: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    loading: _vm.loading.report,
                                    color: "info",
                                    disabled:
                                      !_vm.rissSelectedReportMonthYear.year,
                                  },
                                  on: { click: _vm.downloadRissReport },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-1" }, [
                                    _vm._v("save_alt"),
                                  ]),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("Button.Download")) +
                                      "\n          "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c("v-card-title", { staticClass: "headline" }, [
                            _vm._v("\n          Summary Report\n        "),
                          ]),
                          _vm._v(" "),
                          _c("v-card-text", { staticClass: "pt-0" }, [
                            _vm._v(
                              "\n          Summary report for surface water and process water from a location.\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c("v-autocomplete", {
                                staticStyle: { "max-width": "300px" },
                                attrs: {
                                  label: "Discrete Station",
                                  solo: "",
                                  items: _vm.discreteLocations,
                                  "item-text": "primaryName",
                                  "return-object": "",
                                },
                                model: {
                                  value: _vm.selectedLocation,
                                  callback: function ($$v) {
                                    _vm.selectedLocation = $$v
                                  },
                                  expression: "selectedLocation",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                staticStyle: { "max-width": "300px" },
                                attrs: {
                                  solo: "",
                                  items: _vm.rissSelectItems,
                                  label: _vm.reportLabel,
                                  "single-line": "",
                                  "menu-props": "bottom",
                                  "item-text": "text",
                                  disabled:
                                    !_vm.selectedStationName ||
                                    !_vm.rissSelectItems.length,
                                  "return-object": "",
                                  loading: this.loading.rissMonthYearList,
                                },
                                model: {
                                  value: _vm.rissSelectedReportMonthYear,
                                  callback: function ($$v) {
                                    _vm.rissSelectedReportMonthYear = $$v
                                  },
                                  expression: "rissSelectedReportMonthYear",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-snackbar",
                {
                  attrs: {
                    top: true,
                    timeout: _vm.snackTimeout,
                    vertical: true,
                    color: _vm.snackColor,
                  },
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", flat: "" },
                      on: {
                        click: function ($event) {
                          _vm.snackbar = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("WaterQualityReportsErrorModal", {
        attrs: {
          data: _vm.errorModalData,
          loading: _vm.errorModalLoading,
          customTitle: _vm.customTitle,
        },
        on: {
          download: _vm.onErrorModalCallback,
          cancel: _vm.onErrorModalClose,
        },
        model: {
          value: _vm.errorModal,
          callback: function ($$v) {
            _vm.errorModal = $$v
          },
          expression: "errorModal",
        },
      }),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }